import dayjs, { Dayjs } from "dayjs";

import {
  IGetPatientAdherenceDataResponse,
  IPatientTreatment,
} from "../@types/Treatments";
import { api } from "./api";

// .NET DateTime minimum
const MIN_DATE = dayjs("0001-01-01T00:00:00Z");

export const treatmentsService = {
  async getPatientsAdherenceData(
    date: string
  ): Promise<IGetPatientAdherenceDataResponse[]> {
    const url = "/Portal/NebulizerTreatment/Adherence";

    const serverResponse = await api.post(url, { date });

    if (serverResponse !== undefined) {
      return serverResponse.data.adherence;
    }

    throw Error;
  },

  async getPatientTreatmentsData(
    patientId: number,
    fromDate: Dayjs,
    toDate: Dayjs
  ): Promise<IPatientTreatment[]> {
    const url = "/Portal/NebulizerTreatment/PatientTreatments";

    // Validate fromDate is not below .NET minimum
    const validatedFromDate = fromDate.isBefore(MIN_DATE) ? MIN_DATE : fromDate;

    const serverResponse = await api.post(url, {
      patientId,
      fromDate: validatedFromDate.toISOString(),
      toDate: toDate.toISOString(),
    });

    if (serverResponse !== undefined) {
      return serverResponse.data;
    }

    throw Error;
  },
};
